import * as React from 'react';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { Location, IUtbildningsValProps, IUtbildningsValState } from './YrkesVal.types';
import { FormField } from 'sos-common/js/commonTypes/formField.types';

let Translate: (key: string, defaultValue?: string) => string;
export class UtbildningsTypVal extends React.Component<IUtbildningsValProps, IUtbildningsValState> {
  constructor(props: IUtbildningsValProps) {
    super(props);

    this.state = {
      currentLocation: null,
    };

    Translate = makeTranslator(props.translations);
  }

  setActiveLocation = (value: FormField<Location>) => {
    this.setState({ currentLocation: value.value });
  };

  public render() {
    const { currentYrke, legitimationFormUrl } = this.props;
    const { currentLocation } = this.state;
    return (
      <>
        <div role="log" aria-live="polite">
          {currentYrke && (
            <div className="m-b-2">
              <RadioButtonGroup fieldName="picklocation" onChange={this.setActiveLocation}>
                <RadioButton value={Location.Eu} label={Translate('location/eu')} />
                <RadioButton value={Location.NonEu} label={Translate('location/nonEu3Year')} />
              </RadioButtonGroup>
            </div>
          )}

          {currentLocation === null ? null : currentLocation === Location.Eu ? (
            <>
              <a className="button" href={`${legitimationFormUrl}&NotEuEes=false`}>
                {' '}
                Ansök om specialistkompetens (utbildad inom EU/EES)
              </a>
            </>
          ) : currentLocation === Location.NonEu ? (
            <>
              <a className="button" href={`${legitimationFormUrl}&NotEuEes=true`}>
                Ansök om specialistkompetens (utbildad utanför EU/EES)
              </a>
            </>
          ) : null}
          <div></div>
        </div>
      </>
    );
  }
}
